import React from 'react';
import './contact.css';
import stockage from "images/contact1.png";
import Light from 'components/headers/light';
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhoneVolume, faMobileAlt, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import AnimationRevealPage from 'helpers/AnimationRevealPage';

const ContactUs = () => {
  return (
    <AnimationRevealPage>
      <Light />
      <br />
      <br />
      <br />
      <div className="contact_us_green">
        <div className="container-box">
          <div className="contact-content">
            <div className="text-content">
              <p className="text-blk contactus-head">Contactez-nous</p>
              <br/>

              <p className="text-blk contactus-subhead">Nous sommes heureux de répondre à vos questions et de vous fournir toute l'assistance dont vous avez besoin. Si vous avez des demandes, des préoccupations ou souhaitez simplement nous faire part de vos commentaires, n'hésitez pas à nous contacter.   </p>

              <div className="contact-info">
                <div className="contact-item">
                  <FontAwesomeIcon icon={faPhoneVolume} className="contact-icon" />
                  <p className="contact-text">0523 71 68 04</p>
                </div>

                <div className="contact-item">
                  <FontAwesomeIcon icon={faMobileAlt} className="contact-icon" />
                  <p className="contact-text">+212 677-987453</p>
                </div>

                <div className="contact-item">
                  <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
                  <p className="contact-text">contact@hbm-digital.com</p>
                </div>
              </div>

              <div className="social-media-links">
                <a href="#">
                  <img className="social-svg" src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/gray-insta.svg" alt="instagram" />
                </a>
                <a href="#">
                  <img className="social-svg" src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/gray-fb.svg" alt="facebook" />
                </a>
              </div>
            </div>

            <div className="contact-image">
              <img className="contact-img" src={stockage} alt="Contact" width="100%" />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </AnimationRevealPage>
  );
};

export default ContactUs;
